import { WebpageRecord, WidgetRecord } from "../../../../../interfaces/Interfaces";

import { webpageOptions, widgettypes } from "./WidgetField";

import TextAlignSelector from "./widgets/options/TextAlignSelector";
import MCEEditor from "../../../../../components/HTMLEditor";
import { ColorPicker } from "react-color-palette";
import AlignSelector from "./widgets/options/AlignSelector";
import HtmlNumberSelector from "./widgets/options/HtmlNumberSelector";
import MarginSelector from "./widgets/options/MarginSelector";
import NumberField from "./widgets/options/NumberField";
import SrcSelector from "./widgets/options/SrcSelector";
import ListItemManager from "./widgets/options/ListItemManager";
import FlexAlignSelector from "./widgets/options/FlexAlignSelector";
import TogglePicker from "./widgets/options/TogglePicker";
import MultiSrcSelector from "./widgets/options/MultiSrcSelector";
import VideoSrcSelector from "./widgets/options/VideoSrcSelector";
import CornerSelector from "./widgets/options/CornerSelector";

import { MyColorPicker, MyTextAreaField, MyTextField } from "./Fields";

import { getTranslations } from "../../../../../translations/Translations";
import { Box } from "@mui/material";
import React from "react";

const translations = getTranslations();

const RenderFieldOption = ({
  type,
  data,
  option,
}: {
  type: string;
  data: string;
  option: string;
}) => {
  const optionTitleTranslation = translations[`event.website.options.${option}`];
  const label = optionTitleTranslation ? optionTitleTranslation : option;
  switch (option) {
    case "columns":
      return <NumberField name={`jsonConfig.${option}`} label={label} />;
    case "textAlign":
      return <TextAlignSelector name={`jsonConfig.${option}`} label={label} />;
    case "align":
      return <AlignSelector name={`jsonConfig.${option}`} label={label} />;
    case "alignItems":
      return <FlexAlignSelector name={`jsonConfig.${option}`} label={label} />;
    case "content":
      if (type === "paragraph") {
        return <MCEEditor name={option} isSubmitting={false} title={label} />;
      } else {
        return <MyTextAreaField name={option} label={label} />;
      }
    case "videoSrc":
      return <VideoSrcSelector name={`jsonConfig.${option}`} label={label} />;
    case "src":
    case "backgroundImageSrc":
    case "listimage":
      return <SrcSelector name={`jsonConfig.${option}`} label={label} />;
    case "srcs":
      return <MultiSrcSelector name={`jsonConfig.${option}`} label={label} />;
    case "padding":
    case "margin":
    case "columnPadding":
    case "columnMargin":
      return <MarginSelector name={`jsonConfig.${option}`} label={label} />;
    case "fontSize":
    case "width":
    case "containerWidth":
      return <HtmlNumberSelector name={`jsonConfig.${option}`} label={label} />;
    case "backgroundColor":
    case "columnBackgroundColor":
    case "fontColor":
    case "titleColor":
      return <MyColorPicker name={`jsonConfig.${option}`} label={label} />;
    case "slantedTop":
    case "slantedBottom":
      return null;
    case "listitems":
      return <ListItemManager name={`jsonConfig.${option}`} label={label} />;
    case "showNavigation":
    case "showEventPlan":
      return (
        <TogglePicker name={`jsonConfig.${option}`} yesText={"Ja"} noText={"Nein"} label={label} />
      );
    case "borderRadius":
      return <CornerSelector name={`jsonConfig.${option}`} label={label} />;
    case "buttontext":
      return <MyTextField name={`jsonConfig.${option}`} label={label} />;
    default:
      return <MyTextField name={`jsonConfig.${option}`} label={label} />;
  }
};

const TypeOptions = ({
  webpage,
  widget,
  jsonConfig,
}: {
  webpage?: WebpageRecord;
  widget?: WidgetRecord;
  jsonConfig: string;
}) => {
  if (widget) {
    const widgetTemplate = widgettypes.find((obj) => obj["type"] === widget.type);
    if (widgetTemplate && widgetTemplate.fieldOptions) {
      return (
        <>
          <Box sx={{ mb: "1rem" }}>
            {translations[`event.website.options.type`]}:{" "}
            {translations[`website.widgettype.${widget.type}`]}
          </Box>
          {widgetTemplate.fieldOptions.map((option, index) => {
            return (
              <Box key={`${widget.type}-${index}`} sx={{ mb: "1rem" }}>
                <RenderFieldOption
                  key={`${widget.type}-${index}`}
                  data={jsonConfig}
                  type={widget.type}
                  option={option}
                />
              </Box>
            );
          })}
        </>
      );
    } else {
      return null;
    }
  }

  if (webpage) {
    return (
      <>
        <Box sx={{ mb: "1rem" }}>{translations["website.webpage.settings"]}</Box>
        {webpageOptions.fieldOptions.map((option, index) => {
          return (
            <Box key={`${webpage.type}-${index}`} sx={{ mb: "1rem" }}>
              <RenderFieldOption
                key={`${webpage.type}-${index}`}
                data={jsonConfig}
                type={webpage.type}
                option={option}
              />
            </Box>
          );
        })}
      </>
    );
  }
};

export default TypeOptions;
